import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusFireExtinguisher = () => {
  return (
    <SettingsMetaData propertyName={"Status_FireExtinguisher"} viewPropertyName={"Status"} />
  );
};
export default StatusFireExtinguisher;